export enum NAVIGATION_VIEW_STATES {
  EXPANDED = 'EXPANDED',
  COLLAPSED = 'COLLAPSED',
}
